export const LOAD_SEARCH_FILTERS = 'LOAD_SEARCH_FILTERS';
export const LOAD_SEARCH_INSTRUCTORS = 'LOAD_SEARCH_INSTRUCTORS';
export const SET_SEARCH_FILTERS_LOADING_STATUS = 'SET_SEARCH_FILTERS_LOADING_STATUS';
export const SET_SHOW_ALERT = 'SET_SHOW_ALERT';